import InternationalAddress from './International';
import NationalAddress from './National';

interface IProps {
  name?: string[];
  isForeigner?: boolean;
}

const Address = ({ name, isForeigner }: IProps) => {
  name = name ?? [];

  if (isForeigner) {
    return <InternationalAddress name={name} />;
  }

  return <NationalAddress name={name} />;
};

export default Address;
